<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <v-switch v-model="gradient" :label="$t('gradient_background')" />
        <v-row class="mx-auto" no-gutters>
          <v-col class="pa-2" cols="12" md="6">
            <p>{{ $t("first_color") }}</p>
            <color-picker v-model="data.first" :lable="$t('first_color')" />
          </v-col>

          <v-col v-if="gradient" class="pa-2" cols="12" md="6">
            <p>{{ $t("second_color") }}</p>
            <color-picker v-model="data.second" :lable="$t('second_color')" />
          </v-col>

          <v-col v-if="gradient" class="pa-2" cols="12" md="6">
            <p>{{ $t("gradient_direction") }}</p>
            <div class="rowinfo">
              <v-autocomplete
                v-model="data.dir"
                :items="direction"
                class="col-md-8 contentinfo"
                dense
                hide-details
                item-text="text"
                item-value="value"
                :label="$t('gradient_direction')"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-dir`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('gradient_direction')"
              />
            </div>
          </v-col>

          <v-col class="pa-2" cols="12" md="6">
            <p>{{ $t("text_color") }}</p>
            <color-picker v-model="data.text" :lable="$t('text_color')" />
          </v-col>
        </v-row>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import ColorPicker from "../../qrland/components/colorPicker";

export default {
  name: "colorsComponent",

  components: { ColorPicker },

  props: {
    value: {
      type: Object,
      default: () => ({
        backGround: "linear-gradient(to right, #350808, #270DF5)",
        text: "#fff",
      }),
    },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "colorsComponent-b",
      gradient: true,
      data: {
        first: "#350808",
        second: "#270DF5",
        text: "#fff",
        dir: "to right",
      },
    };
  },

  mounted() {
    this.setColors();
  },

  watch: {
    data: {
      handler(value) {
        if (this.gradient) {
          const grad = `linear-gradient(${this.data.dir} , ${this.data.first}, ${this.data.second})`;
          this.$emit("input", {
            backGround: grad,
            text: value.text,
          });
        } else
          this.$emit("input", {
            backGround: value.first,
            text: value.text,
          });
      },
      deep: true,
    },
  },
  computed: {
    direction() {
      return [
        { text: this.$t("to_top"), value: "to top" },
        { text: this.$t("to_bottom"), value: "to bottom" },
        { text: this.$t("to_left"), value: "to left" },
        { text: this.$t("to_right"), value: "to right" },
        { text: this.$t("to_top_right"), value: "to top right" },
        { text: this.$t("to_top_left"), value: "to top left" },
        { text: this.$t("to_bottom_right"), value: "to bottom right" },
        { text: this.$t("to_bottom_left"), value: "to bottom left" },
      ];
    },
  },
  methods: {
    setColors() {
      if (!!this.value?.backGround) {
        let d = {
          first: "",
          second: "",
          dir: "",
          text: this.value.text,
        };
        let string = this.value.backGround;
        let match = string.match(/to (.+?),/);
        if (match) {
          let words = match[1].split(" ");
          words = words.filter((item) => {
            return item !== "";
          });
          d.dir = "to " + words.join(" ");
        }

        let arr = this.value.backGround.match(/(\#.+)\)/)[1];
        arr = arr.split(", ");
        d.first = arr[0];
        d.second = arr[1];

        this.data = d;
      }
    },
  },
};
</script>
